import {CALL_API} from 'redux/middleware/api'

import {
  MERCHANT,
  MERCHANT_CREATE
} from './'

export function createMerchant(name) {
  return {
    [CALL_API]: {
      endpoint: `merchant`,
      errorsHandled: true,
      method: 'POST',
      types: MERCHANT_CREATE,
      body: {name}
    }
  }
}

export function fetchMerchant() {
  return {
    [CALL_API]: {
      endpoint: `merchant`,
      errorsHandled: true,
      types: MERCHANT
    }
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/merchants/actions.js